



// 



import { Component } from '@angular/core';
import { fadeInOut } from '../../../services/animations';
import { ApiService } from '../../../services/api.service';
import { MatDialog } from '@angular/material';
import { AlertService, DialogType } from '../../../services/alert.service';
import { CreateEditOrgModalComponent } from './create-edit-org-modal/create-edit-org-modal.component';
import { Router } from '@angular/router';
import { Service } from '../../../models/service.model';
import { Org } from '../../../models/org.model';

@Component({
    selector: 'orgs',
    template: require('./orgs.component.html'),
    styles: [require('./orgs.component.css')],
    animations: [fadeInOut]
})
export class OrgsComponent {
    orgs: Org[];
    constructor(private router: Router, private apiService: ApiService, public dialog: MatDialog, private alertService: AlertService) {
        this.getOrgs();
    }

    getOrgs() {
        this.apiService.getOrgs().subscribe(r => {
            this.orgs = r;
        })
    }

    createEditOrg(org: any) {
        let dialogRef = this.dialog.open(CreateEditOrgModalComponent, {
            width: '600px',
            data: {
                currentOrg: org || {},
                //vendors: this.Orgs
            }
        });

        dialogRef.afterClosed().subscribe(r => {
            this.getOrgs();
        })
    }

    deleteOrg(orgId: number) {
        this.alertService.showDialog("Do you want to delete this org ?", DialogType.confirm, val => {

            this.apiService.deleteOrg(orgId).subscribe(r => {
                this.getOrgs();
            });
        });
    }

    onActivate(event) {
        if (event.type === 'click') {
            this.router.navigate(['/orgs/' + event.row.orgId]);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/quote-settings/orgs/orgs.component.ts